var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldBuildPaymentDetails()
    ? _c(
        "div",
        {
          staticClass: "emd-container _type_card",
          attrs: { "data-testid": "container" },
        },
        [
          _c("div", { staticClass: "emd-container__content" }, [
            _c("div", { staticClass: "el-chunk" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t(_vm.paymentMethod + ".title")))]),
            ]),
            _vm.paymentMethod === "checkout"
              ? _c("p", { staticClass: "emd-text _size_small" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t(_vm.paymentMethod + ".subtitle")) + " "
                  ),
                ])
              : _vm._e(),
            _vm.paymentMethod === "credit_card"
              ? _c("div", [
                  _c("p", { staticClass: "emd-text _size_small" }, [
                    _vm._v(_vm._s(_vm.card.holder_name.toUpperCase())),
                  ]),
                  _c("p", { staticClass: "emd-text _size_small" }, [
                    _vm._v(_vm._s(_vm.maskCreditCard(_vm.card.number))),
                  ]),
                  _c("p", { staticClass: "emd-text _size_small" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.creditCard.installments) +
                        " " +
                        _vm._s(_vm.$t("credit_card.installment")) +
                        " " +
                        _vm._s(_vm.installmentValue) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "emd-container__aside" }, [
                    _c("img", { attrs: { alt: "", src: _vm.imageURL } }),
                  ]),
                ])
              : _vm._e(),
            _vm.paymentMethod === "checkout"
              ? _c("div", [
                  _vm.checkout.accepted_payment_methods.includes("boleto")
                    ? _c(
                        "p",
                        {
                          staticClass: "eu-ml_2 emd-text _size_small",
                          attrs: { "data-testid": "checkout-boleto-text" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "checkout.accepted_payment_methods.boleto"
                                )
                              ) +
                              " " +
                              _vm._s(
                                _vm.formatDate(_vm.checkout.boleto.due_at)
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.checkout.accepted_payment_methods.includes("credit_card")
                    ? _c(
                        "p",
                        {
                          staticClass: "eu-ml_2 emd-text _size_small",
                          attrs: { "data-testid": "checkout-credit-card-text" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "checkout.accepted_payment_methods.credit_card"
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.checkout.accepted_payment_methods.includes("pix")
                    ? _c(
                        "p",
                        {
                          staticClass: "eu-ml_2 emd-text _size_small",
                          attrs: { "data-testid": "checkout-pix-text" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("checkout.accepted_payment_methods.pix")
                              ) +
                              " " +
                              _vm._s(
                                _vm.formatDate(_vm.checkout.pix.expires_at)
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.paymentMethod === "pix"
              ? _c("div", [
                  _c("p", { staticClass: "eu-ml_2 emd-text _size_small" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("pix.paymentDetails.expiresAt")) +
                        " " +
                        _vm._s(_vm.formatDate(_vm.pix.expires_at)) +
                        " "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm.isCreditCard() && _vm.getStatementDescriptor
            ? _c(
                "div",
                {
                  staticClass: "emd-container__content",
                  attrs: { "data-testid": "statement-descriptor" },
                },
                [
                  _c("div", { staticClass: "el-chunk" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("statement_descriptor.payment_details")) +
                        " "
                    ),
                  ]),
                  _c("p", { staticClass: "emd-text _size_small" }, [
                    _vm._v(_vm._s(_vm.getStatementDescriptor)),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.isCreditCard()
            ? _c(
                "div",
                {
                  staticClass: "emd-container__content",
                  attrs: { "data-testid": "card-operation-type" },
                },
                [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c("h2", { attrs: { id: "checkout-operation" } }, [
                      _vm._v(_vm._s(_vm.$t("credit_card.operation.label"))),
                    ]),
                  ]),
                  _c("p", { staticClass: "emd-text _size_small" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "credit_card.operation." + _vm.buildCardOperation()
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }